import { deepStrictEqual } from 'assert';
import {
  Cart,
  CartItem,
  CartOptions,
  CartReducerAction,
  CartReducerActionType,
  CartResponseFields,
  CartStore,
  OrderType,
} from '../../app/(routes)/online-ordering/types';
import {
  getGiftCardFields,
  getLocalStorageData,
  getLoginCartData,
  saveCartData,
  syncCartItems,
  normalizeLoyaltyApplied,
} from './utils';
import { getCookie, setCookie } from 'cookies-next';
import { updateCartCustomer } from '../../services/cart/Cart';
import { getCurrentRestaurant, updateCartItemsValidations, sortObjectKeys } from '../../utils/UtilFunctions';
import { DealTerms, IDealDataResponse, RestaurantCustomer, OrderSource } from '@zeus/shared';
import { updateUserAuth } from '@store/online/auth/authSlice';
import { store } from '@store/online/index';
import { setRestaurantSetting } from '@store/online/restaurant/restaurantSlice';
import { updateCartSettings } from '@store/online/cart/cartSlice';
import { decryptData } from '../../utils/Crypto';
import { cookieExpiryTime } from '../../config/constants';

export const reducer = (
  state: CartStore,
  action: CartReducerAction
): Promise<CartStore | Cart | CartResponseFields | CartItem | CartOptions | null | undefined> => {
  return new Promise((resolve) => {
    switch (action.type) {
      case 'syncCart': {
        const data: Cart = action.data as Cart;
        syncCartItems(data)
          .then((responseCart) => {
            if (data?.cartType && data?.cartType === 'remote') {
              delete responseCart['cartType'];
              let quantityFound = false;
              if ((responseCart && responseCart?.quantity) || responseCart?.quantity == 0) {
                quantityFound = true;
                responseCart['orderedQuantity'] = responseCart.quantity;
              }

              const items: CartItem[] = responseCart?.items || [];
              responseCart['discountedPrice'] =
                items.reduce((sum, item) => sum + Number(item?.discountedPrice ?? 0), 0) ?? 0;

              if (responseCart && responseCart.items) {
                for (const [index, item] of responseCart.items.entries()) {
                  const cartItemId = item['id'];

                  if (!quantityFound)
                    responseCart['orderedQuantity'] += responseCart.orderedQuantity || responseCart.quantity || 0;
                  let updatedItem = { ...item };

                  if (updatedItem.item) {
                    updatedItem = {
                      ...updatedItem,
                      ...(({
                        actualPrice,
                        orderedQuantity,
                        isDiscount,
                        discountPercentage,
                        discountedPrice,
                        paymentInfo,
                        ...rest
                      }) => rest)(updatedItem.item),
                    };
                  }

                  if (updatedItem.metaData) {
                    updatedItem = {
                      ...updatedItem,
                      ...(({
                        actualPrice,
                        orderedQuantity,
                        isDiscount,
                        discountPercentage,
                        discountedPrice,
                        paymentInfo,
                        stockStatus,
                        ...rest
                      }) => rest)(updatedItem.metaData),
                      cart_item_id: cartItemId,
                    };

                    delete updatedItem.metaData;
                  }

                  responseCart.items[index] = updatedItem;
                }
              }

              updateCartItemsValidations(responseCart.items);

              resolve(responseCart);
            } else {
              delete responseCart['cartType'];
              resolve(responseCart);
            }
          })
          .catch((error) => {
            console.error('Error while syncing data:', error);
            resolve(null);
          });

        break;
      }
      case 'saveAndSyncCart': {
        const localData = getLocalStorageData();
        const user = store.getState().auth.user;
        const customerUserName = decryptData(user?.customerUserName || '');
        if ((customerUserName || localData.customerUsername) && localData?.guestSessionId) {
          updateCartCustomer(
            localData.resturantAddress.id,
            localData?.guestSessionId,
            customerUserName || localData.customerUsername,
            state?.cart?.order_type || OrderType.Takeaway
          )
            .then((responseCart: Cart | any) => {
              responseCart = responseCart?.data?.data?.cart;
              let quantityFound = false;
              if ((responseCart && responseCart?.quantity) || responseCart?.quantity == 0) {
                quantityFound = true;
                responseCart['orderedQuantity'] = responseCart.quantity;
              }

              const items: CartItem[] = responseCart?.items || [];
              if (responseCart)
                responseCart['discountedPrice'] =
                  items.reduce((sum, item) => sum + Number(item?.discountedPrice ?? 0), 0) ?? 0;

              if (responseCart && responseCart.items) {
                for (const [index, item] of responseCart.items.entries()) {
                  const cartItemId = item['id'];

                  if (!quantityFound)
                    responseCart['orderedQuantity'] += responseCart.orderedQuantity || responseCart.quantity || 0;
                  let updatedItem = { ...item };

                  if (updatedItem.item) {
                    updatedItem = {
                      ...updatedItem,
                      ...(({
                        actualPrice,
                        orderedQuantity,
                        isDiscount,
                        discountPercentage,
                        discountedPrice,
                        ...rest
                      }) => rest)(updatedItem.item),
                    };
                  }

                  if (updatedItem.metaData) {
                    updatedItem = {
                      ...updatedItem,
                      ...(({
                        actualPrice,
                        orderedQuantity,
                        isDiscount,
                        discountPercentage,
                        discountedPrice,
                        ...rest
                      }) => rest)(updatedItem.metaData),
                      cart_item_id: cartItemId,
                    };

                    delete updatedItem.metaData;
                  }

                  responseCart.items[index] = updatedItem;
                }
              }

              const restaurantCustomer = (responseCart?.customer?.restaurantCustomers || []).filter(
                (record: RestaurantCustomer) => record.restaurantId === localData.resturantAddress.id
              );

              if (responseCart)
                responseCart['userPoints'] = restaurantCustomer.length ? restaurantCustomer[0]?.userPoints : 0;

              responseCart = {
                ...responseCart,
                ...(state?.cart?.dealId && {
                  dealId: state?.cart?.dealId,
                  deal: state?.cart?.deal,
                }),
              };

              resolve(responseCart);
            })
            .catch((error) => {
              console.error('Error while saving data:', error);
              resolve(null);
            });
        } else resolve(null);
        break;
      }
      case 'syncLocalCart': {
        const isQr = store.getState().restaurant.isQr;
        const orderSource = isQr ? OrderSource.QR : OrderSource.Website;
        getLoginCartData(
          state?.cart?.restaurantId || 0,
          state?.cart.customerUsername || '',
          state?.cart.guestSessionId || '',
          state?.cart?.order_type || OrderType.Takeaway,
          state?.cart?.orderSource || orderSource || OrderSource.Website
        ).then((response) => {
          const cartData = { ...state.cart, ...response };
          store.dispatch(updateCartSettings({ userCartItem: cartData }));
          const token = getCookie('AccessToken') ?? '';
          if (!token) store.dispatch(updateUserAuth({ user: { phone: null } }));
          store.dispatch(updateUserAuth({ checkoutlogin: false }));
          store.dispatch(setRestaurantSetting({ step: null }));
        });
        break;
      }
      case 'addToCart': {
        const businessId = store.getState().restaurant.selectedBusinessId;
        let updatedItem = structuredClone(action.data as CartItem);
        let updatedCart: Cart = structuredClone(state.cart);
        if (action?.data?.reorder) {
          updatedItem = action?.data?.items;
          updatedCart = action.data.cart || state.cart;
        }

        updatedItem['isSettingsVisible'] = true;

        const giftCardFields = getGiftCardFields(state?.cart);
        const prevCartItems = updatedCart?.items || [];
        const updatedCartItem: CartResponseFields = {
          items: [updatedItem],
          orderedQuantity: 0,
          discountedPrice: 0,
          totalBill: 0,
          actualPrice: 0,
          quantity: 0,
          businessId: businessId ?? undefined,
          ...giftCardFields,
          pointsUsed:
            updatedItem.isLoyaltyApplied && updatedItem.loyaltyAmountApplied
              ? updatedItem.loyaltyAmountApplied
              : state?.cart?.pointsUsed,
          // ...(state?.cart?.dealId && { // Rem
          //   dealId: state?.cart?.dealId,
          //   deal: state?.cart?.deal,
          // }),
          lastAdded: new Date().toISOString(),
        };

        let isUpdateItem = false;
        const discountedPrice = action?.data?.reorder ? updatedItem.itemPrice : Number(updatedItem.discountedPrice);

        for (const prevCartItem of prevCartItems) {
          if (
            prevCartItem.id === updatedItem?.id &&
            prevCartItem.special_instructions === updatedItem?.special_instructions
          ) {
            try {
              const sortedObj1 = sortObjectKeys(prevCartItem.selectedModifierGroups);
              const sortedObj2 = sortObjectKeys(updatedItem?.selectedModifierGroups);

              const sameModifiers = deepStrictEqual(JSON.stringify(sortedObj1), JSON.stringify(sortedObj2));

              if (prevCartItem.isLoyaltyApplied || updatedItem.isLoyaltyApplied) continue;

              if (sameModifiers == undefined && prevCartItem?.deal?.id === updatedCartItem?.deal?.id) {
                isUpdateItem = true;
                prevCartItem.discountedPrice =
                  Number(prevCartItem.discountedPrice) + updatedItem.orderedQuantity * discountedPrice;
                prevCartItem.actualPrice =
                  Number(prevCartItem.actualPrice) + updatedItem.orderedQuantity * discountedPrice;
                prevCartItem.orderedQuantity += updatedItem.orderedQuantity;

                break;
              }
            } catch (error) {
              console.error('Items are not same!');
            }
          }
        }

        if (!isUpdateItem) {
          updatedItem.discountedPrice = updatedItem.orderedQuantity * discountedPrice;
          updatedItem.actualPrice = updatedItem.orderedQuantity * discountedPrice;
        }

        updatedCartItem.discountedPrice =
          Number(updatedCart.discountedPrice) + updatedItem.orderedQuantity * discountedPrice;
        updatedCartItem.actualPrice = Number(updatedCart.actualPrice) + updatedItem.orderedQuantity * discountedPrice;
        updatedCartItem.totalBill = Number(updatedCart.totalBill) + updatedItem.orderedQuantity * discountedPrice;
        updatedCartItem.quantity = (updatedCart?.quantity || 0) + updatedItem.orderedQuantity;

        updatedCartItem.items = isUpdateItem
          ? [...prevCartItems]
          : updatedItem.isLoyaltyApplied
          ? [updatedItem, ...prevCartItems]
          : [...prevCartItems, updatedItem];
        updatedCartItem.orderedQuantity = (updatedCartItem.items ?? []).reduce(
          (acc, current) => acc + current.orderedQuantity,
          0
        );

        resolve(updatedCartItem);
        break;
      }
      case 'removeFromCart': {
        const businessId = store.getState().restaurant.selectedBusinessId;
        const updatedItem = structuredClone(action.data as CartItem);
        const updatedCart: Cart = structuredClone(state.cart);

        const prevCartItems = updatedCart?.items || [];
        let isItemUpdated = false;
        const itemPrice = Number(updatedItem.itemPrice);

        for (let i = 0; i < prevCartItems.length; i++) {
          const prevCartItem = prevCartItems[i];
          if (
            prevCartItem.id === updatedItem?.id &&
            prevCartItem.special_instructions === updatedItem?.special_instructions
          ) {
            try {
              const sortedObj1 = sortObjectKeys(prevCartItem.selectedModifierGroups);
              const sortedObj2 = sortObjectKeys(updatedItem?.selectedModifierGroups);
              const sameModifiers = deepStrictEqual(JSON.stringify(sortedObj1), JSON.stringify(sortedObj2));
              if (sameModifiers == undefined) {
                prevCartItem.orderedQuantity -= updatedItem.orderedQuantity;

                // Remove the item if its quantity drops to 0 or below
                if (prevCartItem.orderedQuantity <= 0) {
                  prevCartItems.splice(i, 1);
                } else {
                  prevCartItem.discountedPrice =
                    Number(prevCartItem.discountedPrice) - updatedItem.orderedQuantity * itemPrice;
                  prevCartItem.actualPrice = Number(prevCartItem.actualPrice) - updatedItem.orderedQuantity * itemPrice;
                }

                isItemUpdated = true;
                break;
              }
            } catch (error) {
              console.error('Error while removing item from cart!');
            }
          }
        }

        if (isItemUpdated) {
          const giftCardFields = getGiftCardFields(state?.cart);
          const updatedCartItem: CartResponseFields = {
            items: prevCartItems,
            discountedPrice: Number(updatedCart.discountedPrice) - updatedItem.orderedQuantity * itemPrice,
            actualPrice: Number(updatedCart.actualPrice) - updatedItem.orderedQuantity * itemPrice,
            totalBill: Number(updatedCart.totalBill) - updatedItem.orderedQuantity * itemPrice,
            quantity: (updatedCart?.quantity || 0) - updatedItem.orderedQuantity,
            businessId: businessId ?? undefined,
            ...giftCardFields,
            ...(state?.cart?.lastAdded && {
              lastAdded: state?.cart?.lastAdded,
            }),
          };
          updatedCartItem.orderedQuantity = (updatedCartItem.items ?? []).reduce(
            (acc, current) => acc + current.orderedQuantity,
            0
          );

          resolve(updatedCartItem);
        } else {
          console.error('Item not found in the cart for removal!');
          // Optional: You might want to reject or resolve with the current state if no item is updated
          resolve(state.cart);
        }

        break;
      }
      case 'updateToCart': {
        const { updatedItem, oldCartItem }: any = action.data;
        updatedItem.isSettingsVisible = true;

        const prevCartItems = [...(state?.cart.items || [])];
        const discountedPrice = Number(updatedItem.discountedPrice);
        let prevOrderedQuantity = 0;
        let prevPrice = 0;

        for (let i = 0; i < prevCartItems.length; i++) {
          const prevCartItem = prevCartItems[i];

          if (
            prevCartItem.id === updatedItem.id &&
            prevCartItem.special_instructions === oldCartItem.special_instructions
          ) {
            const sortedOld = sortObjectKeys(oldCartItem.selectedModifierGroups);
            const sortedPrev = sortObjectKeys(prevCartItem.selectedModifierGroups);
            const sameModifiers = JSON.stringify(sortedOld) === JSON.stringify(sortedPrev);

            const loyaltyMismatch =
              (prevCartItem.isLoyaltyApplied && !updatedItem.loyaltyAmountApplied) ||
              (!prevCartItem.isLoyaltyApplied && updatedItem.loyaltyAmountApplied);

            if (sameModifiers && !loyaltyMismatch) {
              prevOrderedQuantity = Number(prevCartItem.orderedQuantity || 1);
              prevPrice = Number(prevCartItem.discountedPrice || 0) / prevOrderedQuantity;

              prevCartItems[i] = {
                ...updatedItem,
                discountedPrice: updatedItem.orderedQuantity * discountedPrice,
                actualPrice: updatedItem.orderedQuantity * discountedPrice,
                orderedQuantity: updatedItem.orderedQuantity,
              };
              break;
            }
          }
        }

        const updatedCartItem = {
          items: [...prevCartItems],
          pointsUsed: state.cart.pointsUsed,
          ...(state.cart.dealId && {
            dealId: state.cart.dealId,
            deal: state.cart.deal,
          }),
          ...(state.cart.lastAdded && {
            lastAdded: state.cart.lastAdded,
          }),
          discountedPrice:
            Number(state.cart.discountedPrice) -
            prevOrderedQuantity * prevPrice +
            updatedItem.orderedQuantity * discountedPrice,
          actualPrice:
            Number(state.cart.actualPrice) -
            prevOrderedQuantity * prevPrice +
            updatedItem.orderedQuantity * discountedPrice,
          totalBill:
            Number(state.cart.totalBill) -
            prevOrderedQuantity * prevPrice +
            updatedItem.orderedQuantity * discountedPrice,
          orderedQuantity: (state.cart.orderedQuantity || 0) - prevOrderedQuantity + updatedItem.orderedQuantity,
        };

        // 🔁 Merge duplicate items by id + selectedModifierGroups
        const mergedItems: any[] = [];

        for (const item of updatedCartItem.items) {
          const itemCopy = {
            ...item,
            selectedModifierGroups: sortObjectKeys({ ...item.selectedModifierGroups }),
          };
          const existingIndex = mergedItems.findIndex((mergedItem) => {
            const mergedItemCopy = {
              ...mergedItem,
              selectedModifierGroups: sortObjectKeys({ ...mergedItem.selectedModifierGroups }),
            };

            return (
              mergedItemCopy.id === itemCopy.id &&
              JSON.stringify(mergedItemCopy.selectedModifierGroups) ===
                JSON.stringify(itemCopy.selectedModifierGroups) &&
              itemCopy.special_instructions === mergedItemCopy?.special_instructions
              // JSON.stringify(mergedItemCopy) === JSON.stringify(itemCopy)
            );
          });

          if (existingIndex !== -1) {
            const existing = mergedItems[existingIndex];
            const newQuantity = existing.orderedQuantity + item.orderedQuantity;
            const unitPrice = Number(item.discountedPrice) / item.orderedQuantity;

            mergedItems[existingIndex] = {
              ...existing,
              orderedQuantity: newQuantity,
              discountedPrice: unitPrice * newQuantity,
              actualPrice: unitPrice * newQuantity,
            };
          } else {
            mergedItems.push({ ...item });
          }
        }

        updatedCartItem.items = mergedItems;
        resolve({ ...updatedCartItem });
        break;
      }
      case 'incrementQuantityInCart': {
        const data: any = action.data;
        const { item, index } = data;
        const { id } = item;

        if (id) {
          const giftCardFields = getGiftCardFields(state?.cart);
          const prevCartItems = [...(state?.cart.items || [])];
          const updatedCartItem: any = {
            items: [],
            totalBill: 0,
            actualPrice: 0,
            discountedPrice: 0,
            orderedQuantity: 0,
            ...giftCardFields,
            ...(state?.cart?.dealId && {
              dealId: state?.cart?.dealId,
              deal: state?.cart?.deal,
            }),
            ...(state?.cart?.lastAdded && {
              lastAdded: state?.cart?.lastAdded,
            }),
          };

          let netItemPrice = 0;
          let isDiscount = false;
          let discountPercentage = 0;
          let discountedPrice = 0;
          const item = { ...prevCartItems[index] };
          netItemPrice = Number(item.discountedPrice) / Number(item.orderedQuantity || 1);
          isDiscount = item.isDiscount;
          discountPercentage = Number(item.discountPercentage);
          discountedPrice = isDiscount ? netItemPrice - netItemPrice * (discountPercentage / 100) : netItemPrice;
          // if (item.isLoyaltyApplied) continue;
          item.discountedPrice = Number(item.discountedPrice) + discountedPrice;
          item.actualPrice = Number(item.actualPrice) + netItemPrice;
          item.orderedQuantity += 1;

          prevCartItems[index] = item; // ✅ replace updated copy

          updatedCartItem.discountedPrice = Number(state.cart.discountedPrice) + discountedPrice;
          updatedCartItem.actualPrice = Number(state.cart.actualPrice) + netItemPrice;
          updatedCartItem.totalBill = Number(state.cart.totalBill) + discountedPrice;
          updatedCartItem.orderedQuantity = (state?.cart.orderedQuantity || 0) + 1;

          updatedCartItem.items = prevCartItems;

          resolve({ ...updatedCartItem });
        } else resolve({ ...state });

        break;
      }
      case 'decrementQuantityInCart': {
        const data: any = action.data;
        const { item, index, quantity = 1 } = data; // default to 1 if not provided
        const { id } = item;

        if (id) {
          const giftCardFields = getGiftCardFields(state?.cart);
          const prevCartItems = [...(state?.cart.items || [])];
          const updatedCartItem: any = {
            items: [],
            totalBill: 0,
            actualPrice: 0,
            discountedPrice: 0,
            orderedQuantity: 0,
            ...giftCardFields,
            ...(state?.cart?.dealId && {
              dealId: state?.cart?.dealId,
              deal: state?.cart?.deal,
            }),
            ...(state?.cart?.lastAdded && {
              lastAdded: state?.cart?.lastAdded,
            }),
          };

          const cartItem = { ...prevCartItems[index] };
          const currentQty = cartItem.orderedQuantity || 1;
          const decrementQty = Math.min(quantity, currentQty); // prevent over-decrement
          const netItemPrice = Number(cartItem.discountedPrice) / currentQty;
          const isDiscount = cartItem.isDiscount;
          const discountPercentage = Number(cartItem.discountPercentage);
          const discountedPrice = isDiscount ? netItemPrice - netItemPrice * (discountPercentage / 100) : netItemPrice;

          const totalDiscountedPrice = discountedPrice * decrementQty;
          const totalActualPrice = netItemPrice * decrementQty;

          cartItem.discountedPrice = Number(cartItem.discountedPrice) - totalDiscountedPrice;
          cartItem.actualPrice = Number(cartItem.actualPrice) - totalActualPrice;
          cartItem.orderedQuantity -= decrementQty;

          prevCartItems[index] = cartItem;

          updatedCartItem.discountedPrice = Number(state.cart.discountedPrice) - totalDiscountedPrice;
          updatedCartItem.actualPrice = Number(state.cart.actualPrice) - totalActualPrice;
          updatedCartItem.totalBill = Number(state.cart.totalBill) - totalDiscountedPrice;
          updatedCartItem.orderedQuantity = (state?.cart.orderedQuantity || 0) - decrementQty;

          updatedCartItem.items = prevCartItems;

          resolve({ ...updatedCartItem });
        } else resolve({ ...state });

        break;
      }
      case 'saveCart': {
        const newState: Cart = action.data as Cart;
        const refreshToken = getCookie('RefreshToken');
        const businessId = store.getState().restaurant.selectedBusinessId;

        // const cartData = newState ? { ...state.cart, ...newState, refreshToken } : { ...state.cart, refreshToken };
        const restaurant = getCurrentRestaurant();
        const updatedCart = { ...state.cart };

        if (!updatedCart.restaurantId && restaurant) {
          updatedCart.restaurantId = restaurant.id;
        }

        let cartData = newState ? { ...updatedCart, ...newState, refreshToken } : { ...updatedCart, refreshToken };
        if (cartData.businessId === 0) {
          cartData = { ...cartData, businessId: businessId ?? 0 };
        }
        if (!cartData?.restaurantId && cartData?.resturantAddress && cartData?.resturantAddress?.id) {
          cartData.restaurantId = cartData.resturantAddress.id;
        }
        saveCartData(cartData)
          .then((val) => {
            const tokens = val.data?.tokens;
            if (tokens) {
              const cookieOptions = { maxAge: cookieExpiryTime }; // 30 days
              setCookie('AccessToken', tokens.AccessToken, cookieOptions);
              setCookie('IdToken', tokens.IdToken, cookieOptions);
            }
            resolve(null);
          })
          .catch((error) => {
            console.error('Error while saving data:', error);
            resolve({
              error: 'Something went wrong',
            });
          });
        break;
      }
      case 'deleteItem': {
        const data: any = action.data;
        const { id, itemIndex, quantity = 1 } = data;

        if (id) {
          const giftCardFields = getGiftCardFields(state?.cart);
          let prevCartItems = state?.cart.items;
          if (state?.cart?.items) {
            prevCartItems = normalizeLoyaltyApplied(state?.cart?.items);
          }
          const updatedCartItem: any = {
            items: [],
            totalBill: 0,
            actualPrice: 0,
            discountedPrice: 0,
            orderedQuantity: 0,
            ...giftCardFields,
            ...(state?.cart?.dealId && {
              dealId: state?.cart?.dealId,
              deal: state?.cart?.deal,
            }),
            ...(state?.cart?.lastAdded && {
              lastAdded: state?.cart?.lastAdded,
            }),
          };

          let netItemPrice = 0;
          let isDiscount = false;
          let discountPercentage = 0;
          let discountedPrice = 0;

          for (const [index, item] of prevCartItems.entries()) {
            if (item.id === id && index === itemIndex) {
              netItemPrice = Number(item.discountedPrice);
              isDiscount = item.isDiscount;
              discountPercentage = Number(item.discountPercentage);
              discountedPrice = isDiscount ? netItemPrice - netItemPrice * (discountPercentage / 100) : netItemPrice;

              if (item.isLoyaltyApplied) updatedCartItem.pointsUsed = 0;

              break;
            }
          }
          const filteredItems = prevCartItems.filter((_, index) => index !== itemIndex);
          if (filteredItems.length === 0) {
            resolve({
              items: [],
              totalBill: 0,
              actualPrice: 0,
              discountedPrice: 0,
              orderedQuantity: 0,
              pointsUsed: 0,
            });
          }
          updatedCartItem.discountedPrice =
            Math.round((Number(state.cart.discountedPrice) - discountedPrice) * 100) / 100;
          updatedCartItem.actualPrice = Math.round((Number(state.cart.actualPrice) - netItemPrice) * 100) / 100;
          updatedCartItem.totalBill = Math.round((Number(state.cart.totalBill) - discountedPrice) * 100) / 100;
          updatedCartItem.orderedQuantity = Number(state.cart.orderedQuantity || 0) - quantity;

          updatedCartItem.items = [...filteredItems];

          resolve({ ...updatedCartItem });
        } else resolve(null);

        break;
      }
      case 'addDealItems': {
        const dealPayload: CartResponseFields = action.data as CartResponseFields;
        const deal: IDealDataResponse = dealPayload?.deal as IDealDataResponse;
        let dealItems: CartItem[] = dealPayload?.dealItems as CartItem[];
        const businessId = store.getState().restaurant.selectedBusinessId;

        const items = state?.cart?.items || [];
        const filteredIndexes: number[] = [];
        let actualPriceDeducted = 0;
        let discountedPriceDeducted = 0;
        let orderedQuantityDeducted = 0;
        let actualPriceAdded = 0;
        let discountedPriceAdded = 0;
        let orderedQuantityAdded = 0;

        const dealExists = items.some((item: any) => item?.dealId && item?.deal);
        const sameDealExists = items.some((item: any) => Number(item?.dealId) === Number(deal?.id));
        const dontAllowDealExists = items.some(
          (item: any) => item?.dealId && item?.deal && !item.deal.definedTerms.includes(DealTerms.USE_WITH_OTHERS)
        );

        if (
          sameDealExists ||
          dontAllowDealExists ||
          (dealExists && !deal?.definedTerms.includes(DealTerms.USE_WITH_OTHERS))
        ) {
          if (sameDealExists) {
            items.forEach((item: any, index: number) => {
              if (Number(item?.dealId) === Number(deal?.id) || Number(item?.deal?.id) === Number(deal?.id)) {
                filteredIndexes.push(index);
              }
            });
          } else if (dontAllowDealExists || (dealExists && !deal?.definedTerms.includes(DealTerms.USE_WITH_OTHERS))) {
            items.forEach((item: any, index: number) => {
              if (item?.dealId || item?.deal || item?.dealItemType) {
                filteredIndexes.push(index);
              }
            });
          }
        }

        for (const [index, item] of items.entries()) {
          if (filteredIndexes.includes(index)) {
            actualPriceDeducted += Number(item.actualPrice);
            discountedPriceDeducted += Number(item.discountedPrice);
            orderedQuantityDeducted += Number(item.orderedQuantity);
          }
        }
        const filteredItems = items.filter((_, index) => !filteredIndexes.includes(index));

        dealItems = (dealItems || []).map((item: any) => {
          const newItem = structuredClone(item); // clone to be extra safe
          if (item?.dealItemType && item?.dealItemType === 'buy') {
            delete newItem?.dealId;
          }

          actualPriceAdded += Number(item.actualPrice);
          discountedPriceAdded += Number(item.discountedPrice);
          orderedQuantityAdded += Number(item.orderedQuantity);

          return newItem;
        });

        const updatedCart: CartResponseFields = {
          items: [...filteredItems, ...dealItems],
          orderedQuantity: Number(state?.cart?.orderedQuantity || 0) - orderedQuantityDeducted + orderedQuantityAdded,
          discountedPrice: Number(state?.cart?.discountedPrice || 0) - discountedPriceDeducted + discountedPriceAdded,
          totalBill: Number(state?.cart?.discountedPrice || 0) - discountedPriceDeducted + discountedPriceAdded,
          actualPrice: Number(state?.cart?.actualPrice || 0) - actualPriceDeducted + actualPriceAdded,
          businessId: businessId ?? undefined,
          ...(state?.cart?.dealId && {
            dealId: state?.cart?.dealId,
            deal: state?.cart?.deal,
          }),
          lastAdded: new Date().toISOString(),
        };

        resolve(updatedCart);

        break;
      }
      case 'removeDealItems': {
        const dealPayload: CartResponseFields = action.data as CartResponseFields;
        const dealIds: number[] = dealPayload?.dealIds as number[];
        const businessId = store.getState().restaurant.selectedBusinessId;

        const items = state?.cart?.items ? JSON.parse(JSON.stringify(state.cart.items)) : [];
        const filteredIndexes: number[] = [];
        let actualPriceDeducted = 0;
        let discountedPriceDeducted = 0;
        let orderedQuantityDeducted = 0;
        let actualPriceAdded = 0;
        let discountedPriceAdded = 0;
        let orderedQuantityAdded = 0;

        items.forEach((item: any, index: number) => {
          if (
            dealIds.includes(Number(item?.dealId)) ||
            dealIds.includes(Number(item?.deal?.id)) ||
            (dealPayload?.actionType === CartReducerActionType.DeleteItem &&
              item.id === dealPayload.id &&
              index === dealPayload.itemIndex)
          ) {
            filteredIndexes.push(index);
          }
        });

        for (const [index, item] of items.entries()) {
          if (filteredIndexes.includes(index)) {
            actualPriceDeducted += Number(item.actualPrice);
            discountedPriceDeducted += Number(item.discountedPrice);
            orderedQuantityDeducted += Number(item.orderedQuantity);
          } else if (
            dealPayload?.actionType === CartReducerActionType.DecrementInCart &&
            dealPayload?.updatedItem &&
            dealPayload?.updatedItem?.id &&
            dealPayload?.updatedItem?.id === item.id
          ) {
            try {
              const sortedObj1 = sortObjectKeys(item.selectedModifierGroups);
              const sortedObj2 = sortObjectKeys(dealPayload?.updatedItem?.selectedModifierGroups);

              const sameModifiers = deepStrictEqual(JSON.stringify(sortedObj1), JSON.stringify(sortedObj2));

              if (item.isLoyaltyApplied) continue;

              if (sameModifiers == undefined) {
                const netItemPrice = Number(item.discountedPrice) / Number(item.orderedQuantity || 1);
                actualPriceDeducted += netItemPrice;
                discountedPriceDeducted += netItemPrice;
                orderedQuantityDeducted += 1;

                item.discountedPrice = Number(item.discountedPrice) - netItemPrice;
                item.actualPrice = Number(item.actualPrice) - netItemPrice;
                item.orderedQuantity -= 1;
              }
            } catch (error) {
              console.error('Items are not same!');
            }
          } else if (
            dealPayload?.actionType === CartReducerActionType.UpdateInCart &&
            dealPayload?.updatedItem &&
            dealPayload?.oldCartItem &&
            dealPayload?.updatedItem?.id === item.id
          ) {
            try {
              const sortedObj1 = sortObjectKeys(item.selectedModifierGroups);
              const sortedObj2 = sortObjectKeys(dealPayload?.oldCartItem?.selectedModifierGroups);

              const sameModifiers = deepStrictEqual(JSON.stringify(sortedObj1), JSON.stringify(sortedObj2));

              if (
                (item.isLoyaltyApplied && !dealPayload?.updatedItem.loyaltyAmountApplied) ||
                (!item.isLoyaltyApplied && dealPayload?.updatedItem.loyaltyAmountApplied)
              ) {
                continue;
              }

              if (sameModifiers == undefined) {
                const prevOrderedQuantity = Number(item.orderedQuantity || 1);
                const prevPrice = Number(item.discountedPrice || 0) / prevOrderedQuantity;

                actualPriceDeducted += prevPrice * prevOrderedQuantity;
                discountedPriceDeducted += prevPrice * prevOrderedQuantity;
                orderedQuantityDeducted += prevOrderedQuantity;

                items[index] = {
                  ...dealPayload?.updatedItem,
                  discountedPrice:
                    dealPayload?.updatedItem?.orderedQuantity * Number(dealPayload?.updatedItem?.discountedPrice),
                  actualPrice:
                    dealPayload?.updatedItem?.orderedQuantity * Number(dealPayload?.updatedItem?.discountedPrice),
                  orderedQuantity: dealPayload?.updatedItem?.orderedQuantity,
                };
              }
            } catch (error) {
              console.error('Items are not same!');
            }
          }
        }
        if (
          dealPayload?.actionType === CartReducerActionType.UpdateInCart &&
          dealPayload?.updatedItem &&
          dealPayload?.oldCartItem
        ) {
          actualPriceAdded +=
            dealPayload?.updatedItem?.orderedQuantity * Number(dealPayload?.updatedItem?.discountedPrice);
          discountedPriceAdded +=
            dealPayload?.updatedItem?.orderedQuantity * Number(dealPayload?.updatedItem?.discountedPrice);
          orderedQuantityAdded += dealPayload?.updatedItem?.orderedQuantity;
        }

        const filteredItems = items.filter((_: CartItem, index: number) => !filteredIndexes.includes(index));

        const updatedCart: CartResponseFields = {
          items: [...filteredItems],
          orderedQuantity: Number(state?.cart?.orderedQuantity || 0) - orderedQuantityDeducted + orderedQuantityAdded,
          discountedPrice: Number(state?.cart?.discountedPrice || 0) - discountedPriceDeducted + discountedPriceAdded,
          totalBill: Number(state?.cart?.discountedPrice || 0) - discountedPriceDeducted + discountedPriceAdded,
          actualPrice: Number(state?.cart?.actualPrice || 0) - actualPriceDeducted + actualPriceAdded,
          businessId: businessId ?? undefined,
          ...(state?.cart?.dealId && {
            dealId: dealIds.includes(Number(state?.cart?.dealId || state?.cart?.deal?.id))
              ? undefined
              : state?.cart?.dealId,
            deal: dealIds.includes(Number(state?.cart?.dealId || state?.cart?.deal?.id))
              ? undefined
              : state?.cart?.deal,
          }),
          ...(state?.cart?.lastAdded && {
            lastAdded: state?.cart?.lastAdded,
          }),
        };

        resolve(updatedCart);

        break;
      }
      case 'checkDecrementPricing': {
        const data: any = action.data;
        const { id } = data;

        if (id) {
          const prevCartItems = state?.cart.items;

          let discountedPrice = 0;

          for (const item of prevCartItems) {
            if (item.id === id || item.deal || item.dealId) {
              try {
                if (item.deal || item.dealId) {
                  discountedPrice += Number(item.discountedPrice);
                } else {
                  const sortedObj1 = sortObjectKeys(item.selectedModifierGroups);
                  const sortedObj2 = sortObjectKeys(data?.selectedModifierGroups);

                  const sameModifiers = deepStrictEqual(JSON.stringify(sortedObj1), JSON.stringify(sortedObj2));

                  if (item.isLoyaltyApplied) continue;

                  if (sameModifiers == undefined) {
                    discountedPrice += Number(item.discountedPrice) / Number(item.orderedQuantity || 1);
                  }
                }
              } catch (error) {
                console.error('Items are not same!');
              }
            }
          }

          discountedPrice = Number((Number(state.cart.discountedPrice) - discountedPrice).toFixed(2));

          resolve({ ...state?.cart, priceToBeUpdate: discountedPrice });
        } else resolve(null);

        break;
      }
      case 'checkDeletePricing': {
        const data: any = action.data;
        const { id, itemIndex } = data;

        if (id) {
          const prevCartItems = state?.cart.items;

          let discountedPrice = 0;

          for (const [index, item] of prevCartItems.entries()) {
            if ((item.id === id && index === itemIndex) || item.deal || item.dealId) {
              discountedPrice += Number(item.discountedPrice);
            }
          }

          discountedPrice = Number(
            (Math.round((Number(state.cart.discountedPrice) - discountedPrice) * 100) / 100).toFixed(2)
          );

          resolve({ ...state?.cart, priceToBeUpdate: discountedPrice });
        } else resolve(null);

        break;
      }
      case 'checkUpdatePricing': {
        const { updatedItem, oldCartItem }: any = action.data;

        const prevCartItems = state?.cart.items;

        let discountedPrice = 0;

        for (const item of prevCartItems) {
          if (item.id === updatedItem?.id || item.deal || item.dealId) {
            if (item.deal || item.dealId) {
              discountedPrice += Number(item.discountedPrice);
            } else {
              try {
                const sortedObj1 = sortObjectKeys(oldCartItem.selectedModifierGroups);
                const sortedObj2 = sortObjectKeys(item.selectedModifierGroups);

                const sameModifiers = deepStrictEqual(JSON.stringify(sortedObj1), JSON.stringify(sortedObj2));

                if (
                  (item.isLoyaltyApplied && !updatedItem.loyaltyAmountApplied) ||
                  (!item.isLoyaltyApplied && updatedItem.loyaltyAmountApplied)
                ) {
                  continue;
                }

                if (sameModifiers == undefined) {
                  const prevOrderedQuantity = Number(item.orderedQuantity || 1);
                  const prevPrice = Number(item.discountedPrice || 0) / prevOrderedQuantity;

                  discountedPrice += prevPrice * prevOrderedQuantity;
                }
              } catch (error) {
                console.error('Items are not same!');
              }
            }
          }
        }

        discountedPrice = Number(
          (
            Number(state.cart.discountedPrice) -
            discountedPrice +
            updatedItem.orderedQuantity * Number(updatedItem.discountedPrice)
          ).toFixed(2)
        );

        resolve({ ...state?.cart, priceToBeUpdate: discountedPrice });

        break;
      }
      case 'toggleCartOption': {
        const data: CartOptions = action.data as CartOptions;
        resolve(data);
        break;
      }
      case 'setState': {
        const data: CartResponseFields = action.data as CartResponseFields;
        resolve(data);
        break;
      }
      case 'reset': {
        const data = {
          note: '',
          actualPrice: 0,
          discountedPrice: 0,
          orderedQuantity: 0,
          quantity: 0,
          totalBill: 0,
          items: [],
          tipAmount: 0,
          tipPercentage: 0,
          totalTax: 0,
          is_gift_card_applied: false,
          user_gift_card_id: null,
          giftCardAmount: 0,
          giftCard: null,
          id: null,
          error: null,
          deal: null,
          dealId: null,
        };
        resolve(data);
        break;
      }

      default: {
        resolve(state);
        break;
      }
    }
  });
};
